import React, { useState } from 'react';
import { FRIENDS_DATA } from '../content/friends';

function Friends({ app }) {
  const [friendId, setFriendId] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  const handleSendRequest = () => {
    if (friendId.trim()) {
      FRIENDS_DATA.pendingRequests.push(friendId.trim());
      setShowNotification(true);
      setFriendId('');
      setTimeout(() => {
        setShowNotification(false);
      }, 2000);
    }
  };

  return (
    <div className="h-full w-full flex flex-col bg-gray-50 p-6 overflow-auto">
      <div className="max-w-md mx-auto w-full">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Friends</h2>
        
        <div className="bg-white rounded-2xl p-8 mb-6 text-center shadow-sm">
          <p className="text-gray-600 mb-3">Your Friend ID:</p>
          <p className="text-2xl font-mono font-bold text-blue-500 mb-4">{FRIENDS_DATA.playerFriendId}</p>
          <p className="text-gray-500 text-sm">Share this ID with others to connect!</p>
        </div>

        <div className="bg-white rounded-2xl p-6 mb-6 shadow-sm">
          <h3 className="text-lg font-medium text-gray-800 mb-4">Add Friend</h3>
          <div className="flex gap-2">
            <input
              type="text"
              value={friendId}
              onChange={(e) => setFriendId(e.target.value)}
              placeholder="Enter Friend ID"
              className="flex-1 px-4 py-3 bg-gray-100 text-gray-800 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button 
              onClick={handleSendRequest}
              className="px-6 py-3 bg-blue-500 text-white font-medium rounded-xl hover:bg-blue-600 transition-colors shadow-sm"
            >
              Send Request
            </button>
          </div>
        </div>

        {FRIENDS_DATA.pendingRequests.length > 0 && (
          <div className="bg-white rounded-2xl p-6 mb-6 shadow-sm">
            <h3 className="text-lg font-medium text-gray-800 mb-4">Pending Requests</h3>
            <div className="space-y-3">
              {FRIENDS_DATA.pendingRequests.map((requestId, index) => (
                <div key={index} className="flex items-center justify-between bg-gray-50 p-4 rounded-xl">
                  <span className="text-gray-800 font-mono">{requestId}</span>
                  <span className="text-blue-500 text-sm">Pending...</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="bg-white rounded-2xl p-8 text-center shadow-sm">
          <div className="text-gray-500">
            <p>You haven't added any friends yet!</p>
            <p className="text-sm mt-2">Add friends using their Friend ID to see them here</p>
          </div>
        </div>
      </div>

      {showNotification && (
        <div className="fixed bottom-24 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-6 py-3 rounded-xl shadow-lg">
          Friend request sent!
        </div>
      )}
    </div>
  );
}

export default Friends;
